module.exports = __webpack_public_path__ + "static/img/honor_2.0617bee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/honor_2.jpg
// module id = uNNV
// module chunks = 0